export default "__VITE_ASSET__8uZgz7V7__"